import { writable, derived } from 'svelte/store';

export const APP_VERSION = "1.0.1";

export var fleetUtilizationGraph = writable([]);
//export var currentPage = writable([]);

export var selectedPage = writable(0);
export var currentPage = writable("");
export var activeSession = writable(false);
export var selectedDevices = writable([]);
export var selectedDeviceId = writable([]);
export var selectedConfigFile = writable([]);

export var tableData = writable([]);

export var uniqueClientValuesList = writable([]);
export var uniqueConfigValuesList = writable([]);
export var uniqueAppIdValuesList = writable([]);
export var uniqueMobileIdValuesList = writable([]);
export var uniqueFirmwareValuesList = writable([]);
export var uniqueScriptValuesList = writable([]);

export var selectorDeviceId = writable("");
export var selectorConfig = writable("");
export var selectorClient = writable("");
export var selectorFirmware = writable("");
export var selectorAppId = writable("");
export var selectorMobileId = writable("");
export var selectorDate = writable("");
export var selectorScript = writable("");
export var selectorCarrier = writable("");

export var showLoadingModal = writable(false)

export var SESSION_LS = writable("session_id")
export var USERNAME_LS = writable("username")
export var ROLE_LS = writable("role")
export var COMPANY_LS = writable("company")

export var API_DIR = writable("");

export var HARWARE_INFO = writable([
    {
        "APPID": 9,
        "MODEM_SELECT": "Cinterion/Gemalto EHS5 HSPA modem",
        "PART_INFO": "LMU4230H-UBH0-G1000 : LMU4230, HSPA, JPOD, BLUETOOTH, INT ANT, GEN-HW"
    },
    {
        "APPID": 17,
        "MODEM_SELECT": "Cinterion/Gemalto EHS5 HSPA modem",
        "PART_INFO": "LMU0330H-SKM6-G1000 : LMU330, Gemalto HSPA EHS5, SEALED, INT ANT, BATT, MEMS, 6WIRE, GEN-HW"
    },
    {
        "APPID": 39,
        "MODEM_SELECT": "Cinterion/Gemalto EHS5 HSPA modem",
        "PART_INFO": "LMU4232H-UBH0-G1000 : LMU4230, GEMALTO HSPA, 768KB FLASH, JPOD2, BLUETOOTH, 1000MAH BATT, INT ANT, GEN-HW"
    },
    {
        "APPID": 146,
        "MODEM_SELECT": "Cinterion BGS2 GSM/GPRS 2G",
        "PART_INFO": "LMU08G300-G1000 : LMU 820, Cinterion GSM, Int Ant, Gen-HW"
    },
    {
        "APPID": 170,
        "MODEM_SELECT": "Ublox LEON G100 GSM/GPRS",
        "PART_INFO": "LMU27G500-G1000 : LMU 2720, GPRS, Int Ant with battery"
    },
    {
        "APPID": 175,
        "MODEM_SELECT": "Ublox LEON G100 GSM/GPRS",
        "PART_INFO": "LMU42G50J-G1000 : LMU4225, GSM + JPOD"
    },
    {
        "APPID": 184,
        "MODEM_SELECT": "Ublox LEON G100 GSM/GPRS",
        "PART_INFO": "LMU42G50J-G1000 : LMU4225, GSM + JPOD"
    },
    {
        "APPID": 205,
        "MODEM_SELECT": "UBlox SARA GSM/GPRS 2G",
        "PART_INFO": "TTU28G600-G1000 : TTU2830,UBLOX SARA GSM, TRAILER TRACKER, GEN-HW"
    },
    {
        "APPID": 206,
        "MODEM_SELECT": "UBlox LISA U200 HSPA",
        "PART_INFO": "TTU28H400-G1000 : TTU2830,UBLOX HSPA, TRAILER TRACKER, GEN-HW"
    },
    {
        "APPID": 302,
        "MODEM_SELECT": "Cinterion/Gemalto EHS6 HSPA modem",
        "PART_INFO": "TTU2840HE-XAA7-OMT01 : TTU2840, EHS6 HSPA, TRAILER TRACKER, EXTREME, 7-WIRE, OMNITRACS, GEN-HW"
    },
    {
        "APPID": 304,
        "MODEM_SELECT": "Telit LE910-NA LTE modem",
        "PART_INFO": "TTU2840LA-Y012-G1000 : TTU2840, LTE AT&T, EXTREME TWS, 12-WIRE, GEN-HW"
    },
    {
        "APPID": 310,
        "MODEM_SELECT": "Cinterion/Gemalto EHS5 HSPA modem",
        "PART_INFO": "LMU4232H-UBH0-OMTM1 : LMU4230, GEMALTO HSPA, 768KB FLASH, JPOD2, BLUETOOTH, 1000MAH BATT, INT ANT, GEN-HW"
    },
    {
        "APPID": 311,
        "MODEM_SELECT": "Cinterion/Gemalto EHS6 HSPA modem",
        "PART_INFO": "LMU4232HE-VRH0-G1000 : LMU4230, 768KB FLASH, GEMALTO EHS6 HSPA, VPOD2, RS232, 1000MAH BATT, INT, GEN-HW"
    },
    {
        "APPID": 375,
        "MODEM_SELECT": "Telit LE910-NA LTE modem",
        "PART_INFO": "LMU3640LAB-HRZT-OMT03 : LMU3640, TELIT, LTE CAT1, ATT, BLUETOOTH, 1000MAH BATT, RS232, BUZZER, TAG READY, INT ANT, GEN-HW"
    },
    {
        "APPID": 445,
        "MODEM_SELECT": "Quectel BG96 LTE Cat M1 2G FB modem (ATT, VZW, Sprint, Worldwide)",
        "PART_INFO": "TTU2830MB-SQ12-G1000 : TTU2830, CAT M, BG96, BLE, SEALED, 5200 MAH BATT, 12-WIRE, GEN-HW"
    },
    {
        "APPID": 446,
        "MODEM_SELECT": "Quectel BG96 LTE Cat M1 2G FB modem (ATT, VZW, Sprint, Worldwide)",
        "PART_INFO": "LMU3640MB-HRZL-G1000 : LMU3640, LTE CAT M-1WW W/ 2G FB, BLE, 1000 MAH BATT, RS232, BUZZER, LOAD DUMP, GEN-HW"
    }
]);

export var OTAP_STATE = writable(
    {
        "0": "Inactive",
        "1": "Download in progress",
        "2": "Download complete",
        "3": "Download failed",
        "4": "Programming in progress",
        "5": "Programming complete",
        "6": "Programming failed"
    }

)


export var OTAP_DIALOG = writable(
    {
        "0": "None",
        "1": "Invalid file length",
        "2": "Invalid file",
        "3": "Flash erase in progress",
        "4": "Flash erase complete",
        "5": "Flash erase failed",
        "6": "OTA field error",
        "7": "Writing file to flash",
        "8": "HTTP open failed",
        "9": "HTTP premature terminate",
        "10": "Flash verify failed",
        "11": "Flash write failed",
        "12": "Download timeout",
        "13": "CRC check failed",
        "14": "User aborted download",
        "15": "Version incompatible",
        "16": "Invalid URL",
        "17": "Invalid directory",
        "18": "HTTP connect failed",
        "19": "HTTP protocol error",
        "20": "File I/O error",
        "21": "Activity error",
        "23": "Failsafe recovery",
        "24": "Bad DS sign",
        "25": "Download prohibited",
        "26": "Device unresponsive",
        "27": "DS sign required",
        "28": "Firmware update download failed",
        "29": "Firmware update upgrade failed",
        "30": "No VLU box number"
    }

)


